// extracted by mini-css-extract-plugin
module.exports = {"speakers":"SpeakersSlider_speakers__3ASV4","withBtn":"SpeakersSlider_withBtn__Hmq0c","link":"SpeakersSlider_link__3DKvO","slider":"SpeakersSlider_slider__wz3hy"};